// Утилиты для работы с датами

/**
 * Форматирует дату в красивый русский формат (например: "19 августа")
 * @param {string} dateString - дата в формате YYYY-MM-DD
 * @returns {string} - отформатированная дата
 */
export const formatDateToRussian = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  
  const day = date.getDate();
  const month = date.getMonth();
  
  const monthNames = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ];
  
  return `${day} ${monthNames[month]}`;
};

/**
 * Форматирует дату в красивый русский формат с годом (например: "19 августа 2024")
 * @param {string} dateString - дата в формате YYYY-MM-DD
 * @returns {string} - отформатированная дата с годом
 */
export const formatDateToRussianWithYear = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  
  const monthNames = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ];
  
  return `${day} ${monthNames[month]} ${year}`;
};



